import React from "react";
import { timeSince } from "../misc/helperfuncs";

const PlayedInfo = ({ player }) => {
  return (
    <div
      className="divColumn"
      style={{
        backgroundColor: "#5f5f5f",
        width: "100%",
        justifyContent: "space-between",
        alignContent: "center",
        padding: "5px",
      }}
    >
      <Info text={"First Time Played"} lastTime={player?.joined} />
      <div style={{ width: "100%", marginTop: "5px" }}></div>
    </div>
  );
};

const Info = ({ text, lastTime }) => {
  return (
    <div
      className="divRow"
      style={{ width: "100%", justifyContent: "space-between" }}
    >
      <div className="textBoldWhite">{text}</div>
      <div className="divRow" style={{ flex: 1, justifyContent: "center" }}>
        <div
          className="textBoldWhite"
          style={{
            color: "#2f2f2f",
            fontSize: "12px",
            padding: "5px",
            borderRadius: "1rem/1rem",
            backgroundColor: "#7f7f7f",
          }}
        >
          {timeSince(lastTime)} ago
        </div>
      </div>
    </div>
  );
};

export default PlayedInfo;
